import React from "react";
import { useHistory } from "react-router-dom";

const DefaultPage = ({ newChatStart }) => {
  const history = useHistory();
  return (
    <div>
      <div className="DefaultPage card chatting-box mb-0">
        <div
          style={{
            display: "grid",
            gridGap: "10px",
            padding: "1rem",
          }}
        >
          <div
            style={{
              fontSize: "28px",
              color: "#ffffff",
              fontWeight: "600",
              paddingLeft: "10px",
              paddingTop: "1rem",
            }}
          >
            Welcome to Competitive Analytics Insight Tool
          </div>

          <div
            style={{
              color: "#ffffff",
              paddingLeft: "10px",
              width: "80%",
            }}
          >
            Unlock the power of AI-driven insights with our advanced Competitive
            Analytics Insight tool. Designed to streamline your analysis
            process, this tool helps you quickly synthesize complex data from
            various business documents into a concise, easy-to-read summary.
          </div>

          <div
            style={{
              color: "#ffffff",
              fontWeight: "600",
              paddingLeft: "10px",
              fontSize: "18px",
              width: "45%",
            }}
          >
            Features:
          </div>

          <div
            style={{
              color: "#ffffff",
              paddingLeft: "10px",
              fontSize: "14px",
              width: "80%",
            }}
          >
            <b>AI-Driven Synthesis:</b> Our Gen AI tool reads through documents
            like Investor Presentations, Quarterly Reports, and Analyst
            Summaries to create a comprehensive one-page "Competitive
            Intelligence Summary."
          </div>

          <div
            style={{
              color: "#ffffff",
              paddingLeft: "10px",
              fontSize: "14px",
              width: "80%",
            }}
          >
            {" "}
            <b>Predefined Focus Areas:</b> The summary will address key areas
            such as :
            <br />
            <ul style={{ marginBottom: "0px" }}>
              <li>Organic Growth</li>
              <li>Margin</li>
              <li>Product Launch</li>
              <li>Projections</li>
              <li>State of the Consumer</li>
            </ul>
          </div>

          <div
            style={{
              color: "#ffffff",
              paddingLeft: "10px",
              fontSize: "14px",
              width: "80%",
            }}
          >
            {" "}
            <b>Citations Included:</b> The tool provides citations for every
            piece of information, ensuring transparency and reliability.
          </div>

          <div
            style={{
              color: "#ffffff",
              paddingLeft: "10px",
              fontSize: "14px",
              width: "80%",
            }}
          >
            {" "}
            Simplify competitive analysis and gain valuable insights from your
            documents with our efficient AI analytics insight tool.
          </div>
        </div>

        <div className="start-section">
          <div className="start-text" style={{
            display: "flex",
            gap:"20px"
          }} >
            <button
              onClick={newChatStart}
              className="btn-dialog-secondary get-start-btn"
              style={{
                textTransform: "uppercase",
                borderRadius: "6px",
              }}
            >
              Chat
            </button>

            <button
              onClick={() => {
                history.push("/Generate-Summary");
                newChatStart();
              }}
              className="btn-dialog-secondary get-start-btn"
              style={{
                textTransform: "uppercase",
                borderRadius: "6px",
                backgroundColor: "#253978",
              }}
            >
              Summary
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefaultPage;
